import { render, staticRenderFns } from "./SaleUser.vue?vue&type=template&id=27927ca0"
import script from "./SaleUser.vue?vue&type=script&lang=js"
export * from "./SaleUser.vue?vue&type=script&lang=js"
import style0 from "./SaleUser.vue?vue&type=style&index=0&id=27927ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports